// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fU_cf","name":"styles_name__1VAIA","phone":"styles_phone__eD_28"};